import { get as lodashGet } from 'lodash';

import { buildURL } from '../../../helpers/urls';
import { handleResponse } from '../../../helpers/fetch';
import store from '../../../store';

// eslint-disable-next-line import/prefer-default-export
export const importFile = (eventIds, file, importMappingFiles = true) => {
  const url = buildURL('/events/import');
  const formData = new FormData();

  formData.append('file', file);
  formData.append('eventIds', JSON.stringify(eventIds));
  formData.append('importMappingFiles', importMappingFiles);

  return fetch(url, {
    method: 'POST',
    body: formData,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'AMP-User-Id': lodashGet(store.getState(), 'authentication.userData._id', 'dashboard'),
    },
  }).then(handleResponse);
};
